<div class="current" tabindex="0" *ngIf="selectedItem">
  <ng-container *ngIf="selectedItem.icon; else labelItem">
    <span class="button icon" tabindex="0" (click)="toggleOpen()">
      <app-icon
        [alt]="selectedItem.label | translate"
        [src]="selectedItem.icon"
      ></app-icon>
    </span>
    <span *ngIf="multilabel || isItemSelected(selectedItem)" class="label">{{
      selectedItem.label | translate
    }}</span>
  </ng-container>

  <ng-template #labelItem>
    <span class="button" (click)="toggleOpen()">{{
      selectedItem.label | translate
    }}</span>
    <span
      *ngIf="
        selectedItem.sublabel && (multilabel || isItemSelected(selectedItem))
      "
      class="sublabel"
      >{{ selectedItem.sublabel | translate }}</span
    >
  </ng-template>

  <div
    *ngIf="selectedItem.toggle && isItemSelected(selectedItem)"
    class="toggle"
  >
    <latitude-toggle
      [label]="selectedItem.toggle.label"
      (change)="selectedItem.toggle.onChange($event)"
    >
    </latitude-toggle>
  </div>
</div>
<ul [class.disabled]="disabled" [class.open]="open">
  <li
    *ngFor="let item of items"
    [class.selected]="isItemSelected(item)"
    [class.disabled]="item.disabled"
  >
    <ng-container *ngIf="item.icon; else labelItem">
      <span class="button icon" tabindex="0" (click)="selectItem(item)">
        <app-icon [alt]="item.label | translate" [src]="item.icon"></app-icon>
      </span>
      <span *ngIf="multilabel || isItemSelected(item)" class="label">{{
        item.label | translate
      }}</span>
    </ng-container>

    <ng-template #labelItem>
      <span
        class="button"
        [title]="item.sublabel | translate"
        (click)="selectItem(item)"
        >{{ item.label | translate }}</span
      >
      <span
        *ngIf="item.sublabel && (multilabel || isItemSelected(item))"
        class="label"
        >{{ item.sublabel | translate }}</span
      >
    </ng-template>

    <div *ngIf="item.toggle && isItemSelected(item)" class="toggle">
      <latitude-toggle
        [label]="item.toggle.label | translate"
        (change)="item.toggle.onChange($event)"
      >
      </latitude-toggle>
    </div>
  </li>
</ul>
